import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BlockedContextService {
  dynamicField_firstPara: string;
  dynamicField_secondPara: string;
  dynamicField_PrimaryBtnText: string;
  dynamicField_SecondaryBtnText: string;

  constructor() { }

  BLOCKED_PAGE_CONSTANT = {
    BlockedContext2: {
      tipTitle: 'BlockedScreen.IdentifyContext.Overtitle',
      title: 'BlockedScreen.IdentifyContext.Title',
      desc: 'BlockedScreen.IdentifyContext.Body',
      ctaText: 'BlockedScreen.IdentifyContext.PrimaryButton',
      imageUrl: './assets/unauthorized-user-blocked-zennie.json',
      ctaLink: 'https://www.zennie.be/'
    },
    BlockedContext1: {
      tipTitle: 'BlockedScreen.PartnerNotAllowed.Overtitle',
      title: 'BlockedScreen.PartnerNotAllowed.Title',
      desc: 'BlockedScreen.PartnerNotAllowed.Body',
      ctaText: 'BlockedScreen.PartnerNotAllowed.PrimaryButton',
      imageUrl: './assets/unauthorized-user-blocked.json',
      ctaLink: 'https://www.uppie.be/'
    } ,
    BlockedContext3: {
      tipTitle: 'BlockedScreen.PartnerNotAllowedYongo.Overtitle',
      title: 'BlockedScreen.PartnerNotAllowedYongo.Title',
      desc: 'BlockedScreen.PartnerNotAllowedYongo.Body',
      ctaText: 'BlockedScreen.PartnerNotAllowedYongo.PrimaryButton',
      imageUrl: './assets/unauthorized-user-blocked.json',
      ctaLink: 'https://www.aginsurance.be/',
      isPrimaryBtnBlue: true
    } ,
    ExistingContractBlocked :{
      tipTitle: 'BlockedScreen.ExistingLTScontract.Overtitle',
      title: 'BlockedScreen.ExistingLTScontract.Title',
      desc: 'BlockedScreen.ExistingLTScontract.Body',
      ctaText: 'BlockedScreen.ExistingLTScontract.PrimaryButton',
      imageUrl: './assets/images/roadblock-user.svg',
      ctaLink: 'https://www.zennie.be/',
      isPrimaryBtnBlue: true,
    },
    InvalidTokenUppie:{
      tipTitle: 'BlockedScreen.InvalidTokenUppie.Overtitle',
      title: 'BlockedScreen.InvalidTokenUppie.Title',
      desc: 'BlockedScreen.InvalidTokenUppie.Body',
      ctaText: 'BlockedScreen.InvalidTokenUppie.PrimaryButton',
      imageUrl: './assets/unauthorized-user-blocked.json',
      ctaLink: 'https://www.uppie.be/',
      secondaryCtaText: 'BlockedScreen.InvalidTokenUppie.secondaryCtaText',
      isSecondaryButtonVisible: true,
      secondaryCtaLink: 'BlockedScreen.InvalidTokenUppie.secondaryCtaLink'
    },
    InvalidTokenZennie:{
      tipTitle: 'BlockedScreen.InvalidTokenZennie.Overtitle',
      title: 'BlockedScreen.InvalidTokenZennie.Title',
      desc: 'BlockedScreen.InvalidTokenZennie.Body',
      ctaText: 'BlockedScreen.InvalidTokenZennie.PrimaryButton',
      imageUrl: './assets/ingewikkeldPension.json',
      ctaLink: 'https://www.zennie.be/',
      secondaryCtaText: 'BlockedScreen.InvalidTokenZennie.secondaryCtaText',
      isSecondaryButtonVisible: true,
      secondaryCtaLink: 'BlockedScreen.InvalidTokenZennie.secondaryCtaLink'
    },
    SimulationBlocked:{
      tipTitle: 'BlockedScreen.SimulationCheck.Overtitle',
      title: 'BlockedScreen.SimulationCheck.Title',
      desc: 'BlockedScreen.SimulationCheck.Body',
      ctaText: 'BlockedScreen.SimulationCheck.PrimaryButton',
      imageUrl: './assets/unauthorized-user-blocked-zennie.json',
      ctaLink: 'https://www.uppie.be/',
      isSecondaryButtonVisible: true,
      isPrimaryBtnBlue: false,
      secondaryCtaText: 'BlockedScreen.SimulationCheck.SecondaryButton'

    },
    BlockedAge: {
      tipTitle: 'BlockedScreen.Blocked-Age.Overtitle',
      title: 'BlockedScreen.Blocked-Age.Title',
      desc: 'BlockedScreen.Blocked-Age.Body',
      ctaText: 'BlockedScreen.Blocked-Age.PrimaryButton',
      imageUrl: './assets/images/roadblock-user.svg',
      ctaLink: 'https://www.zennie.be/',
      isPrimaryBtnBlue: true,
      adobeStepName: "Blocked user age",
      adobeSubmittrigger: "ab.blocked-user-age"
    },
    BlockedCountry: {
      tipTitle: 'BlockedScreen.Blocked-Country.Overtitle',
      title: 'BlockedScreen.Blocked-Country.Title',
      desc: 'BlockedScreen.Blocked-Country.Body',
      ctaText: 'BlockedScreen.Blocked-Country.PrimaryButton',
      imageUrl: './assets/images/roadblock-user.svg',
      ctaLink: 'https://www.zennie.be/',
      isPrimaryBtnBlue: true,
      adobeStepName: "Blocked user residence",
      adobeSubmittrigger: "ab.blocked-user-residence"
    },
    BlockedAgeRangeYongo: {
      tipTitle: 'BlockedScreen.Blocked-Age-Yongo.Overtitle',
      title: 'BlockedScreen.Blocked-Age-Yongo.Title',
      desc: 'BlockedScreen.Blocked-Age-Yongo.Block-Text',
      ctaText: 'BlockedScreen.Blocked-Age-Yongo.PrimaryButton',
      imageUrl: './assets/images/roadblock-user.svg',
      isPrimaryBtnBlue: true,
      ctaLink: 'https://yongo.be/',
      adobeStepName: "Blocked user age",
      adobeSubmittrigger: "ab.blocked-user-age"
    },
    BlockedCountryRangeYongo: {
      tipTitle: 'BlockedScreen.Blocked-Country-Yongo.Overtitle',
      title: 'BlockedScreen.Blocked-Country-Yongo.Title',
      desc: 'BlockedScreen.Blocked-Country-Yongo.Block-Text',
      ctaText: 'BlockedScreen.Blocked-Country-Yongo.PrimaryButton',
      imageUrl: './assets/images/roadblock-user.svg',
      isPrimaryBtnBlue: true,
      ctaLink: 'https://yongo.be/',
      adobeStepName: "Blocked user residence",
      adobeSubmittrigger: "ab.blocked-user-residence"
    },
    BlockedCountryRangeUppie: {
      tipTitle: 'BlockedScreen.Blocked-Country-Uppie.OverTitle',
      title: 'BlockedScreen.Blocked-Country-Uppie.Title',
      desc: 'BlockedScreen.Blocked-Country-Uppie.Block-Text',
      ctaText: 'BlockedScreen.Blocked-Country-Uppie.Button-text',
      imageUrl: './assets/images/roadblock-user.svg',
      isPrimaryBtnBlue: true,
      ctaLink: 'https://uppie.be/',
      adobeStepName: "Blocked user residence",
      adobeSubmittrigger: "ab.blocked-user-residence"
    },
    BlockedDueToUsedNiss: {
      tipTitle: 'BlockedScreen.Blocked-Used-Niss.Overtitle',
      title: 'BlockedScreen.Blocked-Used-Niss.Title',
      desc: 'BlockedScreen.Blocked-Used-Niss.Block-Text',
      ctaText: 'BlockedScreen.Blocked-Used-Niss.PrimaryButton',
      imageUrl: './assets/ingewikkeldPension.json',
      isPrimaryBtnBlue: true,
      adobeStepName: "Blocked used niss",
      adobeSubmittrigger: "ab.blocked-used-niss"
    },
    BlockedUnmatchedNiss: {
      tipTitle: 'BlockedScreen.Blocked-non-matching-Niss.Overtitle',
      title: 'BlockedScreen.Blocked-non-matching-Niss.Title',
      desc: 'BlockedScreen.Blocked-non-matching-Niss.Block-Text',
      ctaText: 'BlockedScreen.Blocked-non-matching-Niss.PrimaryButton',
      imageUrl: './assets/ingewikkeldPension.json',
      isPrimaryBtnBlue: true,
      adobeStepName: "Blocked non-matching niss",
      adobeSubmittrigger: "ab.blocked-non-matching-niss"
    },
    BlockGeneric: {
      tipTitle: 'BlockedScreen.RedirectionScreenGeneric.Overtitle',
      title: 'BlockedScreen.RedirectionScreenGeneric.Title',
      desc: 'BlockedScreen.RedirectionScreenGeneric.Block-Text',
      ctaText: 'BlockedScreen.RedirectionScreenGeneric.PrimaryButton',
      imageUrl: './assets/images/redirection-screen-generic.svg',
      isPrimaryBtnBlue: true,
      adobeStepName: "Blocked redirection-screen generic",
      adobeSubmittrigger: "ab.blocked-redirection-screen-generic",
      ctaLink:"https://yongo.be/"
    },
    BlockChild: {
      tipTitle: 'BlockedScreen.RedirectionScreenChild.Overtitle',
      title: 'BlockedScreen.RedirectionScreenChild.Title',
      desc: 'BlockedScreen.RedirectionScreenChild.Block-Text',
      ctaText: 'BlockedScreen.RedirectionScreenChild.PrimaryButton',
      imageUrl: './assets/images/redirection-screen-generic.svg',
      isPrimaryBtnBlue: true,
      adobeStepName: "Blocked redirection-screen child",
      adobeSubmittrigger: "ab.blocked-redirection-screen-child",
      ctaLinkFR:"https://www.aginsurance.be/Retail//fr/Pages/myag.aspx",
      ctaLinkNL:"https://www.aginsurance.be/Retail/nl/Paginas/myag.aspx"
    },
    BlockedExpiredIdentification: {
      tipTitle: 'BlockedScreen.Blocked-Expired-ID.Overtitle',
      title: 'BlockedScreen.Blocked-Expired-ID.Title',
      ctaText: 'BlockedScreen.Blocked-Expired-ID.PrimaryButton',
      imageUrl: './assets/images/expired-id.svg',
      isSecondaryButtonVisible: true,
      isPrimaryBtnBlue: false,
      secondaryCtaText: 'BlockedScreen.Blocked-Expired-ID.SecondaryButton'
    },
    BlockUserNissUCIExists: {
      tipTitle: 'BlockedScreen.Niss-Already-Exist.Overtitle',
      title: 'BlockedScreen.Niss-Already-Exist.Title',
      desc: 'BlockedScreen.Niss-Already-Exist.Block-Text',
      imageUrl: './assets/images/come-back-later.svg',
      isSecondaryButtonVisible: false,
      isPrimaryButtonVisible: false
    }
  };
  setFirstParaDynamicField(text: string): void{
    this.dynamicField_firstPara = text;
  }
  setSecondParaDynamicField(text: string): void{
    this.dynamicField_secondPara = text;
  }
  setPrimaryBtnDynamicField(text: string): void{
    this.dynamicField_PrimaryBtnText = text;
  }
  setSecondBtnDynamicField(text: string): void{
    this.dynamicField_SecondaryBtnText = text;
  }
  getFirstParaDynamicField(): string{
    return this.dynamicField_firstPara;
  }
  getSecondParaDynamicField(): string{
    return this.dynamicField_secondPara;
  }
  getPrimaryBtnDynamicField(): string{
    return this.dynamicField_PrimaryBtnText;
  }
  getSecondBtnDynamicField(): string{
    return this.dynamicField_SecondaryBtnText;
  }
}
